











































































































interface curAccount {
  addtax: string;
  accountBookId: number;
  startPeriod: string;
  endPeriod: string;
}
interface tabs {
  text: string;
  tip: string;
  name: string;
  show: boolean;
}

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../../components/MonthSelector.vue";
import AnnualEIT105000, { AnnualEIT105000List } from "./AnnualEIT105000";
import { mapGetters } from "vuex";
@Component({
  ...mapGetters(["accountBook"]),
  components: {}
})
export default class AnnualEITA105000 extends Vue {
  @Prop({ type: Date })
  dateYear: any;

  curAccount: curAccount = {
    addtax: this.$store.state.accountBook.addtax,
    accountBookId: this.$store.state.accountBook.id,
    startPeriod: "",
    endPeriod: ""
  };
  inputRow: AnnualEIT105000List[] = AnnualEIT105000;
  created() {
    this.fetchData();
  }
  fetchData() {
    let year = this.dateYear.getFullYear().toString();
    Vue.axios
      .get(
        `enterpriseincometaxannualfive?accountBookId=${this.$store.state.accountBook.id}&year=${year}`
      )
      .then(res => {
        for (var i = 0; i < this.inputRow.length; i++) {
          this.inputRow[i] = Object.assign(this.inputRow[i], res.data[i]);
        }
      });
  }
  // 切换纳税申报表
  changeType(val: number) {
    if (val === 1) this.fetchData();
    else this.$router.push({ path: "/AnnualEIT" });
  }
  selectInner(e: any) {
    this.$nextTick(() => {
      e.target.select();
    });
  }
  // 修改
  changeTableTwo(row: any) {
    let year = this.dateYear.getFullYear().toString();
    Vue.axios
      .post(
        `enterpriseincometaxannualfive?accountBookId=${this.$store.state.accountBook.id}&year=${year}`,
        row
      )
      .then(res => {
        this.fetchData();
      });
  }
}
